import React from 'react';
import { motion } from 'framer-motion';

export const Reveal = ({ children, delay = 0, y = 40, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children, light = false }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs uppercase tracking-[0.3em] font-sans ${
      light ? 'text-terracotta' : 'text-terracotta-dark'
    }`}
  >
    <span className="h-px w-8 bg-terracotta inline-block" />
    {children}
  </span>
);
